import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter, withViewTransitions, Router } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideFirebaseApp } from '@angular/fire/app';
import { getApp, initializeApp } from 'firebase/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideFirestore, initializeFirestore } from '@angular/fire/firestore';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NG_PROGRESS_CONFIG } from 'ngx-progressbar';
import * as Sentry from '@sentry/angular';

import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';

import { AuthInterceptor } from '@core/interceptors/jwt.interceptor';

import { environment } from '@environment/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useFactory: () => {
        if (environment.production) {
          Sentry.init({
            dsn: 'https://f6363a74324f0269a5d86368ab817c5b@o4509179916517376.ingest.us.sentry.io/4509179955183616',
            integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
            // how many samples would be used to monitor performance
            tracesSampleRate: 0.1,
            // how many sessions would be recorded
            replaysSessionSampleRate: 0,
            // how many sessions with errors would be recorded
            replaysOnErrorSampleRate: 1.0,
            environment: environment.production ? 'production' : 'staging',
          });
          return Sentry.createErrorHandler();
        }
        return new ErrorHandler();
      },
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: NG_PROGRESS_CONFIG,
      useValue: {
        color: '#5854d1',
        thick: true,
      },
    },
    importProvidersFrom(NgProgressHttpModule),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withViewTransitions()),
    provideAnimations(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => {
      const app = getApp();
      const dbName = '(default)';
      const providedFirestore: any = initializeFirestore(app, {}, dbName);
      return providedFirestore;
    }),
    DynamicDialogModule,
    DialogService,
  ],
};
